 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import E9781429904056_COV01 from '@/components/e9781429904056_cov01'
 import LOVE_1 from '@/components/love_1'
 import E9781429904056_TP01 from '@/components/e9781429904056_tp01'
 import E9781429904056_TOC01 from '@/components/e9781429904056_toc01'
 import E9781429904056_C01 from '@/components/e9781429904056_c01'
 import E9781429904056_C02 from '@/components/e9781429904056_c02'
 import E9781429904056_C03 from '@/components/e9781429904056_c03'
 import E9781429904056_C04 from '@/components/e9781429904056_c04'
 import E9781429904056_C05 from '@/components/e9781429904056_c05'
 import E9781429904056_C06 from '@/components/e9781429904056_c06'
 import E9781429904056_C07 from '@/components/e9781429904056_c07'
 import E9781429904056_C08 from '@/components/e9781429904056_c08'
 import E9781429904056_C09 from '@/components/e9781429904056_c09'
 import E9781429904056_C10 from '@/components/e9781429904056_c10'
 import E9781429904056_C11 from '@/components/e9781429904056_c11'
 import E9781429904056_C12 from '@/components/e9781429904056_c12'
 import E9781429904056_C13 from '@/components/e9781429904056_c13'
 import E9781429904056_C14 from '@/components/e9781429904056_c14'
 import E9781429904056_C15 from '@/components/e9781429904056_c15'
 import E9781429904056_C16 from '@/components/e9781429904056_c16'
 import E9781429904056_C17 from '@/components/e9781429904056_c17'
 import E9781429904056_C18 from '@/components/e9781429904056_c18'
 import E9781429904056_C19 from '@/components/e9781429904056_c19'
 import E9781429904056_C20 from '@/components/e9781429904056_c20'
 import E9781429904056_C21 from '@/components/e9781429904056_c21'
 import E9781429904056_C22 from '@/components/e9781429904056_c22'
 import E9781429904056_C23 from '@/components/e9781429904056_c23'
 import E9781429904056_C24 from '@/components/e9781429904056_c24'
 import E9781429904056_C25 from '@/components/e9781429904056_c25'
 import E9781429904056_C26 from '@/components/e9781429904056_c26'
 import E9781429904056_C27 from '@/components/e9781429904056_c27'
 import E9781429904056_C28 from '@/components/e9781429904056_c28'
 import E9781429904056_C29 from '@/components/e9781429904056_c29'
 import E9781429904056_C30 from '@/components/e9781429904056_c30'
 import E9781429904056_C31 from '@/components/e9781429904056_c31'
 import LOVE_2 from '@/components/love_2'
 import E9781429904056_ALS01 from '@/components/e9781429904056_als01'
 import E9781429904056_BM01 from '@/components/e9781429904056_bm01'
 import E9781429904056_IND01 from '@/components/e9781429904056_ind01'
 import E9781429904056_FTN01 from '@/components/e9781429904056_ftn01'
 import E9781429904056_COP01 from '@/components/e9781429904056_cop01'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/e9781429904056_toc01",
 			"name" : "e9781429904056_toc01",
 			"component" : E9781429904056_TOC01
 		},
 		{
 			"path" : "/e9781429904056_c01",
 			"name" : "e9781429904056_c01",
 			"component" : E9781429904056_C01
 		},
 		{
 			"path" : "/e9781429904056_c02",
 			"name" : "e9781429904056_c02",
 			"component" : E9781429904056_C02
 		},
 		{
 			"path" : "/e9781429904056_c03",
 			"name" : "e9781429904056_c03",
 			"component" : E9781429904056_C03
 		},
 		{
 			"path" : "/e9781429904056_c04",
 			"name" : "e9781429904056_c04",
 			"component" : E9781429904056_C04
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js